module.exports = __webpack_public_path__ + "img/customer5.fd659b2a.png";